import React from 'react';
import { Box } from '@heycater/design-system';
import { Grid } from '@material-ui/core';
import Image from 'next/image';
import styled from 'styled-components';

import RequestForm from 'static_pages/marketing_pages/customer_landing_page/components/RequestForm';

function RequestSection() {
  return (
    <>
      <Box pb={{ xs: 5, sm: 10 }} pt={{ sm: 6, md: 0 }}>
        <Grid container spacing={2}>
          <StyledGrid item sm={12} md={4}>
            <ImageWrapper>
              <Image
                alt="People eating"
                src="/artifacts/images/marketing_pages/company-lunch.webp"
                width={448}
                height={411}
              />
            </ImageWrapper>
          </StyledGrid>
          <Grid item xs={12} sm={12} md={8}>
            <RequestForm />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

const StyledGrid = styled(Grid)`
  margin: auto;

  ${(props) => props.theme.breakpoints.down('sm')} {
    display: none;
  }
`;

const ImageWrapper = styled.div`
  overflow: hidden;
  border-radius: ${(props) => props.theme.spacing(1.5)}px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    text-align: center;
  }
`;

export default RequestSection;
